var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPass({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8V7C15 4.243 12.757 2 10 2C7.243 2 5 4.243 5 7V8C4.44772 8 4 8.44772 4 9C4 11.5 4 14 4 16.5C4 17.3284 4.67157 18 5.5 18H14.5C15.3284 18 16 17.3284 16 16.5C16 14 16 11.5 16 9C16 8.44772 15.5523 8 15 8ZM9 15H11V11H9V15ZM13 8H7V7C7 5.346 8.346 4 10 4C11.654 4 13 5.346 13 7V8Z",
    fill: "#AFB3B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/pass.01709f03a75a27cd3663ef94f46fe734.svg";
export { ForwardRef as ReactComponent };